import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { UserService } from '@forwardflow/services/UserService'
import useSWR from 'swr'
import { useNavigate } from 'react-router-dom'

export default function useAuthUser({
   revalidateOnMount = false,
}: {
   revalidateOnMount?: boolean
}) {
   const navigate = useNavigate()

   const response = useSWR([QUERY_KEYS.AUTH_USER], UserService.getUserData, {
      revalidateOnFocus: true,
      revalidateOnMount,
      onError: (error) => {
         console.error('Error fetching user data:', error)
         navigate('/logout')
      },
   })

   return {
      ...response,
   }
}
